var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.0338 1.66406C11.4254 1.66406 11.7504 1.98073 11.7504 2.38073V17.6224C11.7504 18.0141 11.4338 18.3391 11.0338 18.3391C6.12544 18.3391 2.70044 14.9141 2.70044 10.0057C2.70044 5.0974 6.13377 1.66406 11.0338 1.66406Z",
    fill: "#2E37A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1164 9.61875L14.7497 7.24375C14.5081 7.00208 14.1081 7.00208 13.8664 7.24375C13.6247 7.48542 13.6247 7.88542 13.8664 8.12708L15.1664 9.42708H7.19141C6.84974 9.42708 6.56641 9.71042 6.56641 10.0521C6.56641 10.3938 6.84974 10.6771 7.19141 10.6771H15.1664L13.8664 11.9771C13.6247 12.2188 13.6247 12.6188 13.8664 12.8604C13.9914 12.9854 14.1497 13.0438 14.3081 13.0438C14.4664 13.0438 14.6247 12.9854 14.7497 12.8604L17.1164 10.4854C17.3581 10.2521 17.3581 9.86042 17.1164 9.61875Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b497ecff62f3853a7ac57513cbdcd00b.svg";
export { ForwardRef as ReactComponent };